import { render, staticRenderFns } from "./ModalLightBox.vue?vue&type=template&id=6a8a0d92&"
import script from "./ModalLightBox.vue?vue&type=script&lang=js&"
export * from "./ModalLightBox.vue?vue&type=script&lang=js&"
import style0 from "./ModalLightBox.vue?vue&type=style&index=0&id=6a8a0d92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports